module.exports = __webpack_public_path__ + "img/interational_air_img_2.aeccae27.png";